import { Component, Injector } from '@angular/core';

import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';


@Component({
  selector: 'app-equipment-constructors-list',
  templateUrl: './equipment-constructors-list.component.html',
  styles: []
})
export class EquipmentConstructorsListComponent extends GenericListComponent {
  constructor(public injector: Injector) {
    super(injector);
  }
}
